// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAV4Ao5HcA4_j3hW_qJCagHmBgWQuijauI",
  authDomain: "crypto-market-19462.firebaseapp.com",
  projectId: "crypto-market-19462",
  storageBucket: "crypto-market-19462.appspot.com",
  messagingSenderId: "1007993947157",
  appId: "1:1007993947157:web:58eff0ae6a857f2a1e7a1c",
  measurementId: "G-DS31H3QV7R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
